import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface AppState {
  isDarkMode: boolean
  toggleDarkMode: () => void
}

export const useStore = create<AppState>()(
  persist(
    (set) => ({
      isDarkMode: false,
      toggleDarkMode: () => set((state) => ({ isDarkMode: !state.isDarkMode })),
    }),
    {
      name: 'app-storage',
    }
  )
) 